import { IEvents, } from "@walletconnect/jsonrpc-types";
export class IJsonRpcHistory extends IEvents {
    constructor(client, logger) {
        super();
        this.client = client;
        this.logger = logger;
        this.records = new Map();
    }
}
//# sourceMappingURL=history.js.map